module.exports = __webpack_public_path__ + "img/smallFont.0ddc8561.svg";